import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { ClockIcon, BellIcon } from 'lucide-react';
interface ComingSoonPageProps {
  title?: string;
  description?: string;
}
export function ComingSoonPage({
  title = 'Coming Soon',
  description = "We're working hard to bring you this page. Check back soon for updates!"
}: ComingSoonPageProps) {
  return <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex flex-col" data-id="element-176">
      <Header data-id="element-177" />

      <main className="flex-grow flex items-center justify-center pt-32 pb-20 px-4" data-id="element-178">
        <div className="max-w-2xl w-full text-center" data-id="element-179">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-blue-100 text-blue-600 mb-8" data-id="element-180">
            <ClockIcon className="w-12 h-12" data-id="element-181" />
          </div>

          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl font-black text-gray-900 mb-6 uppercase tracking-tight" data-id="element-182">
            {title}
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-600 mb-8 font-medium" data-id="element-183">
            {description}
          </p>

          {/* Notify Section */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 mb-8" data-id="element-184">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-185">
              <BellIcon className="w-6 h-6 text-blue-600" data-id="element-186" />
              <h2 className="text-xl font-bold text-gray-900" data-id="element-187">Get Notified</h2>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-188">
              Enter your email to be notified when this page launches.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-id="element-189">
              <input type="email" placeholder="your@email.com" className="flex-grow px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-190" />
              <Button variant="primary" className="whitespace-nowrap" data-id="element-191">
                Notify Me
              </Button>
            </div>
          </div>

          {/* Back to Home */}
          <a href="/" className="inline-flex items-center text-blue-600 font-bold hover:text-blue-700 transition-colors" data-id="element-192">
            ← Back to Home
          </a>
        </div>
      </main>

      <Footer data-id="element-193" />
    </div>;
}